(function () {
  'use strict';

  var AUTO_ADVANCE_DELAY = 350;
  var STATE_VERSION = 4;
  var LEAD_STORAGE_KEY = 'os_quiz_lead';

  function parseTags(raw) {
    var tags = {};
    if (!raw) return tags;
    raw.split(',').forEach(function (part) {
      part = part.trim();
      if (!part) return;
      var pieces = part.split(':');
      var tag = pieces[0].trim();
      var weight = parseFloat(pieces[1]);
      if (!tag) return;
      tags[tag] = (tags[tag] || 0) + (isNaN(weight) ? 1 : weight);
    });
    return tags;
  }

  function ProductQuiz(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id') || '';
    this.persist = root.getAttribute('data-persist') === 'true';
    this.syncCart = root.getAttribute('data-sync-cart-attributes') === 'true';
    this.fallbackTag = root.getAttribute('data-fallback-tag') || '';
    this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    this.storageKey = 'os_quiz_state_' + this.sectionId;

    this.intro = root.querySelector('[data-quiz-intro]');
    this.stepsContainer = root.querySelector('[data-quiz-steps]');
    this.steps = this.stepsContainer
      ? Array.prototype.slice.call(this.stepsContainer.querySelectorAll('[data-quiz-step]'))
      : [];
    this.resultsPanel = root.querySelector('[data-quiz-results]');
    this.results = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-result]'));
    this.bundleLink = root.querySelector('[data-quiz-bundle-link]');
    this.bundleLinkLabel = root.querySelector('[data-quiz-bundle-link-label]');
    this.progress = root.querySelector('[data-quiz-progress]');
    this.progressEnabled = !!this.progress && !this.progress.classList.contains('product-quiz__progress--none');
    this.progressFill = root.querySelector('[data-quiz-progress-fill]');
    this.progressDots = this.progress ? Array.prototype.slice.call(this.progress.querySelectorAll('[data-quiz-dot]')) : [];
    this.progressCurrent = root.querySelector('[data-quiz-current]');
    this.emailInput = root.querySelector('[data-quiz-email-input]');
    this.emailError = root.querySelector('[data-quiz-email-error]');

    this.index = 0;
    this.answers = {};
    this.bundleTag = '';
    this.firstName = '';
    this.phone = '';
    this.smsOptIn = false;
    this.email = '';
    this.emailCaptured = false;

    this.bindEvents();
    this.root.__productQuiz = this;
    this.restore();
    this.bindResize();

    var self = this;
    window.requestAnimationFrame(function () {
      self.equalizeStepHeights();
    });
  }

  ProductQuiz.prototype.bindEvents = function () {
    var self = this;

    var startButton = this.root.querySelector('[data-quiz-start]');
    if (startButton) {
      startButton.addEventListener('click', function () {
        self.begin();
      });
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('input', function () {
        if (self.emailError) self.emailError.hidden = true;
        self.emailInput.removeAttribute('aria-invalid');
      });
    }

    if (this.bundleLink) {
      this.bundleLink.addEventListener('click', function (event) {
        self.handleBundleLinkClick(event);
      });
    }

    Array.prototype.slice.call(this.root.querySelectorAll('[data-quiz-retake]')).forEach(function (retakeButton) {
      retakeButton.addEventListener('click', function () {
        self.retake();
      });
    });

    // "Shop All" (bottom of the Bundle Builder embed) adds every component
    // of the currently-matched result's bundle at once — the exact same
    // individual-items add as the Order Summary's combined Add to Cart
    // button, just reachable from further down the page. Resolved at click
    // time (not bound to one result up front) since this button, like
    // data-quiz-bundle-link, is a single shared element rendered once after
    // all (mostly-hidden) result blocks, not duplicated per result.
    var shopAllBtn = this.root.querySelector('[data-quiz-shop-all]');
    if (shopAllBtn) {
      shopAllBtn.addEventListener('click', function () {
        var matched = self.results.filter(function (resultEl) {
          return !resultEl.hidden;
        })[0];
        if (!matched) return;

        var featuredItem = self.getCartSourceEl(matched);
        var statusEl = self.root.querySelector('[data-quiz-shop-all-status]');
        if (featuredItem) self.addItemToCart(featuredItem, shopAllBtn, statusEl, 'subscribe');
      });
    }

    this.steps.forEach(function (step) {
      var optionsWrap = step.querySelector('[data-quiz-options]');
      if (optionsWrap) {
        optionsWrap.addEventListener('click', function (event) {
          var option = event.target.closest('[data-quiz-option]');
          if (!option) return;
          self.handleOptionClick(step, option);
        });
      }

      var scale = step.querySelector('[data-quiz-scale], [data-quiz-number]');
      if (scale) {
        scale.addEventListener('input', function () {
          self.handleScaleInput(step, scale);
        });
      }

      var nextButton = step.querySelector('[data-quiz-next]');
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          self.next();
        });
      }

      var skipButton = step.querySelector('[data-quiz-skip]');
      if (skipButton) {
        skipButton.addEventListener('click', function () {
          self.skip(step);
        });
      }

      var backButton = step.querySelector('[data-quiz-back]');
      if (backButton) {
        backButton.addEventListener('click', function () {
          self.back();
        });
      }

      var lead = step.querySelector('[data-quiz-lead]');
      if (lead) {
        lead.addEventListener('input', function () {
          self.updateNextButtonState(step);
        });
        lead.addEventListener('change', function () {
          self.updateNextButtonState(step);
        });
      }
    });

    this.results.forEach(function (resultEl) {
      Array.prototype.slice.call(resultEl.querySelectorAll('[data-quiz-item]')).forEach(function (item) {
        var select = item.querySelector('[data-quiz-item-variant]');
        var priceEl = item.querySelector('[data-quiz-item-price]');
        if (select && priceEl) {
          select.addEventListener('change', function () {
            var option = select.options[select.selectedIndex];
            if (option && option.getAttribute('data-price')) {
              priceEl.textContent = option.getAttribute('data-price');
            }
          });
        }

        var addButton = item.querySelector('[data-quiz-item-add]');
        if (addButton) {
          addButton.addEventListener('click', function () {
            self.addItemToCart(item, addButton);
          });
        }

        self.bindPurchaseToggle(item, resultEl);
        self.bindSelectRemove(item, resultEl);
      });
    });

    this.root.addEventListener('click', function (event) {
      self.handleOrderSummaryClick(event);
    }, true);
  };

  ProductQuiz.prototype.handleOrderSummaryClick = function (event) {
    var addBtn = event.target.closest('[data-order-summary-add]');
    var otpBtn = event.target.closest('[data-order-summary-onetime]');
    if (!addBtn && !otpBtn) return;
    if (addBtn && otpBtn) otpBtn = null;

    var btn = addBtn || otpBtn;
    var resultEl = btn.closest('[data-quiz-result]');
    if (!resultEl) return;

    event.preventDefault();

    var source = this.getCartSourceEl(resultEl) || resultEl;
    var statusEl = resultEl.querySelector('[data-order-summary-status]');
    this.addItemToCart(source, btn, statusEl, addBtn ? 'subscribe' : 'onetime');
  };

  // Subscribe & Save / One-Time price toggle on the featured card — swaps
  // the displayed price/compare text and re-drives the Order Summary total,
  // which always tracks whichever purchase type is currently active.
  ProductQuiz.prototype.bindPurchaseToggle = function (item, resultEl) {
    var self = this;
    var toggle = item.querySelector('[data-quiz-purchase-toggle]');
    if (!toggle) return;

    var priceEl = item.querySelector('[data-quiz-item-price]');
    var options = Array.prototype.slice.call(toggle.querySelectorAll('[data-quiz-purchase-option]'));

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (other) {
          var isActive = other === option;
          other.classList.toggle('is-active', isActive);
          other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        var cents = parseInt(option.getAttribute('data-price-cents'), 10) || 0;
        if (priceEl) priceEl.innerHTML = self.formatPriceHTML(cents);

        self.recomputeOrderSummary(resultEl);
      });
    });
  };

  // "Selected" (disabled while qty >= 1) / "Remove" (sets qty to 0, flips
  // back to an enabled "Select" button) — the single include/exclude
  // toggle for this whole bundle recommendation. One quantity input is the
  // source of truth; Order Summary just reflects it.
  ProductQuiz.prototype.bindSelectRemove = function (item, resultEl) {
    var self = this;
    var selectRow = item.querySelector('[data-quiz-select-row]');
    if (!selectRow) return;

    var qtyInput = item.querySelector('.quantity__input');
    var selectBtn = item.querySelector('[data-quiz-select-btn]');

    var sync = function () {
      self.syncFeaturedSelection(item, resultEl);
    };

    if (qtyInput) qtyInput.addEventListener('change', sync);

    if (selectBtn) {
      selectBtn.addEventListener('click', function () {
        if (!qtyInput || (parseInt(qtyInput.value, 10) || 0) > 0) return;
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    var removeBtn = item.querySelector('[data-quiz-remove-btn]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = 0;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    sync();
  };

  ProductQuiz.prototype.syncFeaturedSelection = function (item, resultEl) {
    var qtyInput = item.querySelector('.quantity__input');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
    var selectBtn = item.querySelector('[data-quiz-select-btn]');
    var selectBtnLabel = item.querySelector('[data-quiz-select-btn-label]');
    var removeBtn = item.querySelector('[data-quiz-remove-btn]');

    var selected = qty > 0;

    if (selectBtn) selectBtn.disabled = selected;
    if (selectBtnLabel) selectBtnLabel.textContent = selected ? 'Selected' : 'Select';
    if (removeBtn) removeBtn.hidden = !selected;
    item.classList.toggle('is-removed', !selected);

    this.recomputeOrderSummary(resultEl);
  };

  ProductQuiz.prototype.formatMoney = function (cents) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    return (this.moneyFormat || '${{amount}}')
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', amount);
  };

  // Splits into a big "$103" + small underlined ".82" pair (matches the
  // .product-quiz__bundle-item-price-dollars/-cents markup rendered
  // server-side in snippets/quiz-bundle-item.liquid) instead of one flat
  // string, so the Subscribe/One-Time toggle's client-side price swap keeps
  // the same styled look as the initial render.
  ProductQuiz.prototype.formatPriceHTML = function (cents) {
    var dollars = Math.floor(cents / 100);
    var remainder = cents % 100;
    var centsStr = (remainder < 10 ? '0' : '') + remainder;
    return '<span class="product-quiz__bundle-item-price-dollars">$' + dollars +
      '</span><span class="product-quiz__bundle-item-price-cents">' + centsStr + '</span>';
  };

  ProductQuiz.prototype.recomputeOrderSummary = function (resultEl) {
    var summary = resultEl.querySelector('[data-quiz-order-summary]');
    var item = resultEl.querySelector('[data-quiz-item][data-bundle-cart-items]');
    if (!summary || !item) return;

    var qtyInput = item.querySelector('.quantity__input');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 1;
    var componentsTotalCents = parseInt(summary.getAttribute('data-components-total-cents'), 10) || 0;
    var subscribeCents = parseInt(summary.getAttribute('data-subscribe-cents'), 10) || 0;
    var onetimeCents = parseInt(summary.getAttribute('data-onetime-cents'), 10) || 0;
    var priceEl = item.querySelector('[data-quiz-item-price]');
    if (!subscribeCents) {
      subscribeCents = parseInt((priceEl && priceEl.getAttribute('data-cents-subscribe')) || '0', 10);
    }
    if (!onetimeCents) {
      onetimeCents = parseInt((priceEl && priceEl.getAttribute('data-cents-onetime')) || '0', 10);
    }

    var totalEl = summary.querySelector('[data-order-summary-total]');
    var emptyEl = summary.querySelector('[data-order-summary-empty]');
    var addBtns = resultEl.querySelectorAll('[data-order-summary-add]');
    var onetimeBtns = resultEl.querySelectorAll('[data-order-summary-onetime]');
    var frequencyEl = summary.querySelector('[data-order-summary-frequency]');
    var subheadingEl = summary.querySelector('[data-order-summary-subheading]');

    if (qty <= 0) {
      if (totalEl) totalEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      Array.prototype.slice.call(addBtns).forEach(function (addBtn) { addBtn.disabled = true; });
      Array.prototype.slice.call(onetimeBtns).forEach(function (onetimeBtn) { onetimeBtn.hidden = true; });
      if (frequencyEl) frequencyEl.hidden = true;
      if (subheadingEl) subheadingEl.hidden = true;
      return;
    }

    if (totalEl) totalEl.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
    Array.prototype.slice.call(addBtns).forEach(function (addBtn) { addBtn.disabled = false; });
    Array.prototype.slice.call(onetimeBtns).forEach(function (onetimeBtn) { onetimeBtn.hidden = false; });
    if (frequencyEl) frequencyEl.hidden = false;

    var compareCents = componentsTotalCents * qty;
    var finalCents = subscribeCents * qty;
    var otpCents = onetimeCents * qty;
    var compareEl = summary.querySelector('[data-order-summary-total-compare]');
    var priceOut = summary.querySelector('[data-order-summary-total-price]');
    var otpPrice = summary.querySelector('[data-order-summary-onetime-price]');
    if (compareEl) {
      compareEl.textContent = this.formatMoney(compareCents);
      compareEl.hidden = !(compareCents > finalCents);
    }
    if (priceOut) priceOut.textContent = this.formatMoney(finalCents);
    if (otpPrice) otpPrice.textContent = this.formatMoney(otpCents);

    if (subheadingEl) {
      var savingsEl = subheadingEl.querySelector('[data-order-summary-savings]');
      var badgeEl = subheadingEl.querySelector('[data-order-summary-badge]');
      if (componentsTotalCents > 0 && subscribeCents < componentsTotalCents) {
        var saved = (componentsTotalCents - subscribeCents) * qty;
        var pct = Math.round((1 - subscribeCents / componentsTotalCents) * 100);
        if (pct > 0) {
          if (savingsEl) savingsEl.textContent = this.formatMoney(saved);
          if (badgeEl) badgeEl.textContent = 'Save ' + pct + '%';
          subheadingEl.hidden = false;
        } else {
          subheadingEl.hidden = true;
        }
      } else {
        subheadingEl.hidden = true;
      }
    }
  };

  ProductQuiz.prototype.bindResize = function () {
    var self = this;
    var timer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        self.equalizeStepHeights();
      }, 150);
    });
  };

  ProductQuiz.prototype.equalizeStepHeights = function () {
    if (!this.steps.length) return;
    var max = 0;

    this.steps.forEach(function (step) {
      var content = step.querySelector('.product-quiz__step-content');
      if (!content) return;

      var wasHidden = step.hidden;
      var prevPosition = step.style.position;
      var prevVisibility = step.style.visibility;
      var prevMinHeight = content.style.minHeight;

      step.hidden = false;
      step.style.position = 'absolute';
      step.style.visibility = 'hidden';
      content.style.minHeight = '0px';

      if (content.offsetHeight > max) max = content.offsetHeight;

      step.hidden = wasHidden;
      step.style.position = prevPosition;
      step.style.visibility = prevVisibility;
      content.style.minHeight = prevMinHeight;
    });

    if (max > 0) {
      this.root.style.setProperty('--pq-step-min-height', max + 'px');
    }
  };

  ProductQuiz.prototype.restore = function () {
    this.loadLeadFromStorage();

    var stored = this.persist ? this.readStorage() : null;

    // A stored entry from an older STATE_VERSION was written by JS that
    // didn't know about fields the current code depends on (e.g. per-answer
    // "goals") — replaying it would silently look like "shopper picked
    // nothing" instead of "this data predates the feature." Treat it as if
    // nothing were stored, and clear it so it doesn't keep resurfacing.
    if (stored && stored.version !== STATE_VERSION) {
      this.clearStorage();
      stored = null;
    }

    if (stored && stored.email) {
      this.email = stored.email;
      this.emailCaptured = true;
      if (this.emailInput) this.emailInput.value = stored.email;
    }
    if (stored) {
      this.bundleTag = stored.bundleTag || '';
      this.firstName = stored.firstName || this.firstName;
      this.phone = stored.phone || this.phone;
      this.smsOptIn = !!stored.smsOptIn;
      this.persistLeadStorage();
    }

    this.applyLeadFields(true);

    if (stored && stored.completed) {
      this.answers = stored.answers || {};
      this.syncBundleTagFromAnswers();
      this.showResults(stored.resultTag || this.bundleTag, false);
      return;
    }

    if (stored && this.steps.length) {
      this.answers = stored.answers || {};
      this.syncBundleTagFromAnswers();
      this.applyStoredSelections();
      if (this.intro) this.intro.hidden = true;
      if (this.progress) this.progress.hidden = !this.progressEnabled;
      this.showStep(this.nearestVisibleIndex(Math.min(stored.index || 0, this.steps.length - 1)));
      return;
    }

    if (this.intro) {
      if (this.progress) this.progress.hidden = true;
      this.updateProgress();
      return;
    }

    if (this.steps.length) {
      this.showStep(0);
    }
  };

  ProductQuiz.prototype.applyStoredSelections = function () {
    var self = this;
    this.steps.forEach(function (step, index) {
      var answer = self.answers[index];
      if (!answer) return;

      if (answer.type === 'scale' || answer.type === 'number') {
        var scale = step.querySelector('[data-quiz-scale], [data-quiz-number]');
        var output = step.querySelector('[data-quiz-scale-value]');
        if (scale) scale.value = answer.value;
        if (output) output.textContent = self.formatScaleValue(scale);
        self.setNextEnabled(step, true);
        return;
      }

      if (answer.type === 'flavor' && answer.flavors) {
        Object.keys(answer.flavors).forEach(function (handle) {
          var select = step.querySelector('[data-quiz-bundle-flavor][data-product-handle="' + handle + '"]');
          if (select) select.value = answer.flavors[handle];
        });
        self.updateNextButtonState(step);
        return;
      }

      if (answer.type === 'lead') {
        var first = step.querySelector('[data-quiz-lead-first-name]');
        var email = step.querySelector('[data-quiz-lead-email]');
        var phone = step.querySelector('[data-quiz-lead-phone]');
        var sms = step.querySelector('[data-quiz-lead-sms]');
        if (first) first.value = self.firstName || '';
        if (email) email.value = self.email || '';
        if (phone) phone.value = self.phone || '';
        if (sms) sms.checked = self.smsOptIn;
        self.updateNextButtonState(step);
        return;
      }

      var options = Array.prototype.slice.call(step.querySelectorAll('[data-quiz-option]'));
      var selectedValues = answer.values || [];
      options.forEach(function (option) {
        var isSelected = selectedValues.indexOf(option.getAttribute('data-value')) !== -1;
        option.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
      self.updateNextButtonState(step);
    });
  };

  ProductQuiz.prototype.begin = function () {
    if (this.emailInput && !this.validateEmail()) return;
    if (this.emailInput) this.captureEmail();

    if (this.intro) this.intro.hidden = true;
    if (this.progress) this.progress.hidden = !this.progressEnabled;
    this.showStep(0);
    this.dispatchStarted();
  };

  ProductQuiz.prototype.validateEmail = function () {
    var value = (this.emailInput.value || '').trim();
    var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    if (this.emailError) this.emailError.hidden = valid;
    if (valid) {
      this.emailInput.removeAttribute('aria-invalid');
      this.email = value;
    } else {
      this.emailInput.setAttribute('aria-invalid', 'true');
      this.emailInput.focus();
    }

    return valid;
  };

  ProductQuiz.prototype.captureEmail = function () {
    if (this.emailCaptured) return;
    this.emailCaptured = true;
    this.persistLeadStorage();
    this.persistState();
    this.root.dispatchEvent(new CustomEvent('product-quiz:email-captured', {
      detail: { email: this.email, firstName: this.firstName, phone: this.phone, smsOptIn: this.smsOptIn },
      bubbles: true
    }));
  };

  ProductQuiz.prototype.stepIsVisible = function (step) {
    var role = step.getAttribute('data-quiz-role') || 'branch';
    var path = step.getAttribute('data-quiz-path') || 'all';
    if (role === 'router' || role === 'universal') return true;
    if (role === 'lead') return !!this.bundleTag;
    if (path === 'all' || path === '') return true;
    if (!this.bundleTag) return false;
    return path === this.bundleTag;
  };

  ProductQuiz.prototype.getVisibleSteps = function () {
    return this.steps.filter(this.stepIsVisible, this);
  };

  ProductQuiz.prototype.nearestVisibleIndex = function (index) {
    var visible = this.getVisibleSteps();
    if (!visible.length) return Math.max(0, Math.min(index, this.steps.length - 1));
    var lastBefore = -1;
    var i;
    var vi;
    for (i = 0; i < visible.length; i++) {
      vi = this.steps.indexOf(visible[i]);
      if (vi === index) return index;
      if (vi < index) lastBefore = vi;
      if (vi > index) return lastBefore >= 0 ? lastBefore : vi;
    }
    return lastBefore >= 0 ? lastBefore : this.steps.indexOf(visible[0]);
  };

  ProductQuiz.prototype.clearOffPathAnswers = function () {
    var self = this;
    this.steps.forEach(function (step, index) {
      if (self.stepIsVisible(step)) return;
      delete self.answers[index];
    });
  };

  ProductQuiz.prototype.syncBundleTagFromAnswers = function () {
    var self = this;
    this.steps.forEach(function (step, index) {
      if (step.getAttribute('data-quiz-role') !== 'router') return;
      var answer = self.answers[index];
      var tags = answer && answer.tags ? Object.keys(answer.tags) : [];
      if (tags.length) self.bundleTag = tags[0];
    });
  };

  ProductQuiz.prototype.dispatchStarted = function () {
    this.root.dispatchEvent(new CustomEvent('product-quiz:started', {
      detail: { email: this.email, totalSteps: this.steps.length },
      bubbles: true
    }));
  };

  ProductQuiz.prototype.handleOptionClick = function (step, option) {
    var inputType = step.getAttribute('data-input-type');
    var index = parseInt(step.getAttribute('data-step-index'), 10);
    var options = Array.prototype.slice.call(step.querySelectorAll('[data-quiz-option]'));

    if (inputType === 'multi_choice') {
      var nowSelected = option.getAttribute('aria-checked') !== 'true';
      option.setAttribute('aria-checked', nowSelected ? 'true' : 'false');
    } else {
      options.forEach(function (other) {
        other.setAttribute('aria-checked', other === option ? 'true' : 'false');
      });
    }

    this.recordChoiceAnswer(step, index, options);
    this.updateNextButtonState(step);
    this.persistState();

    if (inputType === 'choice') {
      var self = this;
      window.setTimeout(function () {
        self.next();
      }, AUTO_ADVANCE_DELAY);
    }
  };

  ProductQuiz.prototype.recordChoiceAnswer = function (step, index, options) {
    var question = step.getAttribute('data-question') || '';
    var selected = options.filter(function (option) {
      return option.getAttribute('aria-checked') === 'true';
    });

    var tags = {};
    var values = [];
    var goals = [];
    selected.forEach(function (option) {
      values.push(option.getAttribute('data-value') || option.textContent.trim());
      var optionTags = parseTags(option.getAttribute('data-tags'));
      Object.keys(optionTags).forEach(function (tag) {
        tags[tag] = (tags[tag] || 0) + optionTags[tag];
      });
      var goalAttr = (option.getAttribute('data-goal') || '').trim();
      if (goalAttr) {
        goalAttr.split(',').forEach(function (goal) {
          goal = goal.trim();
          if (goal) goals.push(goal);
        });
      }
    });

    this.answers[index] = {
      question: question,
      type: step.getAttribute('data-input-type'),
      values: values,
      tags: tags,
      goals: goals,
      klaviyoProperty: step.getAttribute('data-klaviyo-property') || ''
    };

    if (step.getAttribute('data-quiz-role') === 'router') {
      var tagKeys = Object.keys(tags);
      this.bundleTag = tagKeys[0] || this.fallbackTag;
      this.clearOffPathAnswers();
    }
  };

  // Flattens the "goal" labels attached to every selected option across all
  // answered questions (see data-goal on .product-quiz__option, sourced
  // from the 4th pipe-delimited segment of a step's `options` setting) into
  // one de-duplicated, answer-order list — this is what "Your goal:" shows,
  // as a live reflection of what the shopper actually picked rather than
  // static per-result marketing copy.
  ProductQuiz.prototype.collectSelectedGoals = function () {
    var seen = {};
    var goals = [];
    Object.keys(this.answers).sort(function (a, b) {
      return parseInt(a, 10) - parseInt(b, 10);
    }).forEach(function (key) {
      (this.answers[key].goals || []).forEach(function (goal) {
        if (seen[goal]) return;
        seen[goal] = true;
        goals.push(goal);
      });
    }, this);
    return goals;
  };

  ProductQuiz.prototype.handleScaleInput = function (step, scale) {
    var index = parseInt(step.getAttribute('data-step-index'), 10);
    var question = step.getAttribute('data-question') || '';
    var output = step.querySelector('[data-quiz-scale-value]');
    if (output) output.textContent = this.formatScaleValue(scale);

    this.answers[index] = {
      question: question,
      type: step.getAttribute('data-input-type'),
      value: scale.value,
      unit: scale.getAttribute('data-unit') || '',
      tags: {}
    };

    this.setNextEnabled(step, true);
    this.persistState();
  };

  ProductQuiz.prototype.formatScaleValue = function (scale) {
    var unit = scale.getAttribute('data-unit') || '';
    return unit ? scale.value + ' ' + unit : scale.value;
  };

  ProductQuiz.prototype.updateNextButtonState = function (step) {
    var inputType = step.getAttribute('data-input-type');
    var role = step.getAttribute('data-quiz-role');
    var required = step.getAttribute('data-required') === 'true';

    if (role === 'flavor' || inputType === 'flavor') {
      this.setNextEnabled(step, true);
      return;
    }

    if (role === 'lead' || inputType === 'lead') {
      this.setNextEnabled(step, this.leadIsValid(step));
      return;
    }

    if (inputType === 'scale' || inputType === 'number') {
      this.setNextEnabled(step, true);
      return;
    }

    if (!required) {
      this.setNextEnabled(step, true);
      return;
    }

    var selectedCount = step.querySelectorAll('[data-quiz-option][aria-checked="true"]').length;

    if (inputType === 'multi_choice') {
      var min = parseInt(step.getAttribute('data-min'), 10) || 0;
      var max = parseInt(step.getAttribute('data-max'), 10) || Infinity;
      this.setNextEnabled(step, selectedCount >= min && selectedCount <= max);
    } else {
      this.setNextEnabled(step, selectedCount > 0);
    }
  };

  ProductQuiz.prototype.setNextEnabled = function (step, enabled) {
    var nextButton = step.querySelector('[data-quiz-next]');
    if (nextButton) nextButton.disabled = !enabled;
  };

  ProductQuiz.prototype.showStep = function (index) {
    var self = this;
    if (!this.steps[index] || !this.stepIsVisible(this.steps[index])) {
      index = this.nearestVisibleIndex(index);
    }
    this.index = index;

    this.steps.forEach(function (step, i) {
      var isCurrent = i === index;
      step.hidden = !isCurrent;
      if (!isCurrent) return;
      var backButton = step.querySelector('[data-quiz-back]');
      if (backButton) backButton.hidden = self.getVisibleSteps().indexOf(step) <= 0 && !self.intro;
      if (step.getAttribute('data-quiz-role') === 'lead') self.applyLeadFields(false);
      self.updateNextButtonState(step);
      var heading = step.querySelector('.product-quiz__question');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    });

    this.updateProgress();
    this.persistState();
  };

  ProductQuiz.prototype.updateProgress = function () {
    var visible = this.getVisibleSteps();
    if (!this.progress || !visible.length) return;

    var currentStep = this.steps[this.index];
    var pos = visible.indexOf(currentStep);
    var current = (pos < 0 ? 0 : pos) + 1;
    this.progress.setAttribute('aria-valuenow', String(current));
    this.progress.setAttribute('aria-valuemax', String(visible.length));

    if (this.progressFill) {
      this.progressFill.style.width = (current / visible.length) * 100 + '%';
    }

    if (this.progressDots.length) {
      this.progressDots.forEach(function (dot, i) {
        dot.hidden = i >= visible.length;
        dot.setAttribute('data-active', i < current ? 'true' : 'false');
      });
    }

    if (this.progressCurrent) {
      this.progressCurrent.textContent = String(current);
    }
  };

  ProductQuiz.prototype.next = function () {
    var step = this.steps[this.index];
    if (step && (step.getAttribute('data-quiz-role') === 'lead') && !this.validateLead(step)) return;

    this.recordSpecialStep(this.index);
    this.dispatchStepAnswered(this.index);
    this.advance();
  };

  ProductQuiz.prototype.skip = function (step) {
    var index = parseInt(step.getAttribute('data-step-index'), 10);
    this.answers[index] = {
      question: step.getAttribute('data-question') || '',
      type: 'flavor',
      skipped: true,
      values: [],
      flavors: {},
      klaviyoProperty: step.getAttribute('data-klaviyo-property') || ''
    };
    this.persistState();
    this.dispatchStepAnswered(index);
    this.advance();
  };

  ProductQuiz.prototype.advance = function () {
    var visible = this.getVisibleSteps();
    var step = this.steps[this.index];
    var pos = visible.indexOf(step);
    var nextIndex = -1;
    var i;
    var vi;

    if (pos >= 0) {
      if (pos + 1 >= visible.length) {
        if (!this.bundleTag) return;
        this.finish();
        return;
      }
      nextIndex = this.steps.indexOf(visible[pos + 1]);
    } else {
      for (i = 0; i < visible.length; i++) {
        vi = this.steps.indexOf(visible[i]);
        if (vi > this.index) {
          nextIndex = vi;
          break;
        }
      }
    }

    if (nextIndex < 0) {
      if (!this.bundleTag) return;
      this.finish();
      return;
    }
    this.showStep(nextIndex);
  };

  ProductQuiz.prototype.recordSpecialStep = function (index) {
    var step = this.steps[index];
    if (!step) return;
    var role = step.getAttribute('data-quiz-role');
    if (role === 'flavor') this.recordFlavorAnswer(step, index);
    if (role === 'lead') this.recordLeadAnswer(step, index);
  };

  ProductQuiz.prototype.recordFlavorAnswer = function (step, index) {
    if (this.answers[index] && this.answers[index].skipped) return;
    var flavors = {};
    var values = [];
    Array.prototype.slice.call(step.querySelectorAll('[data-quiz-bundle-flavor]')).forEach(function (select) {
      var handle = select.getAttribute('data-product-handle');
      var option = select.options[select.selectedIndex];
      if (!handle || !option) return;
      flavors[handle] = option.value;
      var labelEl = select.closest('label') && select.closest('label').querySelector('.product-quiz__flavor-label');
      var label = labelEl ? labelEl.textContent.trim() : handle;
      values.push(label + ': ' + option.textContent.trim());
    });
    this.answers[index] = {
      question: step.getAttribute('data-question') || '',
      type: 'flavor',
      skipped: false,
      values: values,
      flavors: flavors,
      klaviyoProperty: step.getAttribute('data-klaviyo-property') || ''
    };
  };

  ProductQuiz.prototype.leadIsValid = function (step) {
    var first = step.querySelector('[data-quiz-lead-first-name]');
    var email = step.querySelector('[data-quiz-lead-email]');
    var firstVal = first ? first.value.trim() : '';
    var emailVal = email ? email.value.trim() : '';
    return firstVal.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
  };

  ProductQuiz.prototype.validateLead = function (step) {
    var valid = this.leadIsValid(step);
    var error = step.querySelector('[data-quiz-lead-error]');
    if (error) error.hidden = valid;
    var email = step.querySelector('[data-quiz-lead-email]');
    if (email) {
      if (valid) email.removeAttribute('aria-invalid');
      else email.setAttribute('aria-invalid', 'true');
    }
    if (!valid) {
      var first = step.querySelector('[data-quiz-lead-first-name]');
      if (first && !first.value.trim()) first.focus();
      else if (email) email.focus();
    }
    return valid;
  };

  ProductQuiz.prototype.recordLeadAnswer = function (step, index) {
    var first = step.querySelector('[data-quiz-lead-first-name]');
    var email = step.querySelector('[data-quiz-lead-email]');
    var phone = step.querySelector('[data-quiz-lead-phone]');
    var sms = step.querySelector('[data-quiz-lead-sms]');
    this.firstName = first ? first.value.trim() : '';
    this.email = email ? email.value.trim() : '';
    this.phone = phone ? phone.value.trim() : '';
    this.smsOptIn = !!(sms && sms.checked);
    this.answers[index] = {
      question: step.getAttribute('data-question') || 'Contact',
      type: 'lead',
      values: [this.firstName, this.email, this.phone].filter(Boolean),
      klaviyoProperty: step.getAttribute('data-klaviyo-property') || ''
    };
    this.persistLeadStorage();
    this.captureEmail();
  };

  ProductQuiz.prototype.dispatchStepAnswered = function (index) {
    var answer = this.answers[index];
    if (!answer) return;

    this.root.dispatchEvent(new CustomEvent('product-quiz:step-answered', {
      detail: {
        stepIndex: index,
        totalSteps: this.getVisibleSteps().length,
        question: answer.question,
        value: answer.value,
        values: answer.values,
        tags: answer.tags,
        email: this.email
      },
      bubbles: true
    }));
  };

  ProductQuiz.prototype.back = function () {
    var visible = this.getVisibleSteps();
    var pos = visible.indexOf(this.steps[this.index]);
    if (pos <= 0) {
      if (this.intro) {
        if (this.steps[this.index]) this.steps[this.index].hidden = true;
        this.intro.hidden = false;
        if (this.progress) this.progress.hidden = true;
      }
      return;
    }
    this.showStep(this.steps.indexOf(visible[pos - 1]));
  };

  ProductQuiz.prototype.pickWinningTag = function () {
    this.syncBundleTagFromAnswers();
    return this.bundleTag || this.fallbackTag;
  };

  ProductQuiz.prototype.finish = function () {
    var winningTag = this.pickWinningTag();
    this.showResults(winningTag, true);
  };

  ProductQuiz.prototype.showResults = function (winningTag, isNewCompletion) {
    if (this.stepsContainer) this.stepsContainer.hidden = true;
    if (this.progress) this.progress.hidden = true;
    if (this.intro) this.intro.hidden = true;

    var matched = null;
    this.results.forEach(function (resultEl) {
      var isMatch = resultEl.getAttribute('data-result-tag') === winningTag;
      resultEl.hidden = !isMatch;
      if (isMatch && !matched) matched = resultEl;
    });
    if (!matched && this.results.length) {
      matched = this.results[0];
      matched.hidden = false;
    }

    this.updateBundleLink(matched);
    this.dispatchResultShown(matched, winningTag);

    if (matched) {
      var featuredItem = matched.querySelector('[data-quiz-select-row]');
      if (featuredItem) this.syncFeaturedSelection(featuredItem.closest('[data-quiz-item]'), matched);
      this.renderGoalPills(matched);
      this.applyQuizFlavorsToResult(matched);
      this.renderPersonalization(matched);
    }

    if (this.resultsPanel) this.resultsPanel.hidden = false;

    if (isNewCompletion) {
      this.persistState(winningTag, true);
      if (this.syncCart) this.syncCartAttributes(matched, winningTag);
      this.dispatchComplete(matched, winningTag);
    }
  };

  // Overlays the "Your goal:" pills with what the shopper actually selected
  // (see collectSelectedGoals). Leaves the merchant's static server-rendered
  // pills (block.settings.goal_labels) alone when no answered question had
  // a data-goal configured — dynamic takes priority, static is the fallback.
  ProductQuiz.prototype.renderGoalPills = function (resultEl) {
    var goals = this.collectSelectedGoals();
    var row = resultEl.querySelector('.product-quiz__goal-row');

    // Snapshot the merchant's static markup the first time we see it, so a
    // later retake with no data-goal answers can restore it instead of
    // being left with whatever dynamic pills happened to run last.
    if (row && row.getAttribute('data-static-html') === null) {
      row.setAttribute('data-static-html', row.innerHTML);
    }

    if (!goals.length) {
      if (row && row.getAttribute('data-js-created') === 'true') {
        row.parentNode.removeChild(row);
      } else if (row) {
        var staticHtml = row.getAttribute('data-static-html');
        if (staticHtml !== null) row.innerHTML = staticHtml;
      }
      return;
    }

    if (!row) {
      row = document.createElement('div');
      row.className = 'product-quiz__goal-row';
      row.setAttribute('data-js-created', 'true');
      var label = document.createElement('span');
      label.className = 'product-quiz__goal-label';
      label.textContent = 'Your goal:';
      row.appendChild(label);

      var divider = resultEl.querySelector('.product-quiz__results-divider');
      if (divider && divider.parentNode) {
        divider.parentNode.insertBefore(row, divider.nextSibling);
      } else {
        resultEl.insertBefore(row, resultEl.firstChild);
      }
    }

    Array.prototype.slice.call(row.querySelectorAll('.product-quiz__goal-pill')).forEach(function (pill) {
      pill.parentNode.removeChild(pill);
    });

    goals.forEach(function (goal) {
      var pill = document.createElement('span');
      pill.className = 'product-quiz__goal-pill';
      pill.textContent = goal;
      row.appendChild(pill);
    });
  };

  ProductQuiz.prototype.dispatchResultShown = function (matchedResultEl, winningTag) {
    // Fires every time a result becomes visible — fresh completion or
    // restored from localStorage on page load — unlike `product-quiz:complete`
    // (fresh completions only, meant for analytics/conversion tracking).
    // Other scripts that need to sync UI to "whichever result is showing"
    // (e.g. the Bundle Builder Featured-badge bridge) should listen to this
    // one instead.
    this.root.dispatchEvent(new CustomEvent('product-quiz:result-shown', {
      detail: { tag: winningTag, resultEl: matchedResultEl },
      bubbles: true
    }));
  };

  ProductQuiz.prototype.updateBundleLink = function (matchedResultEl) {
    if (!this.bundleLink) return;

    var url = matchedResultEl ? matchedResultEl.getAttribute('data-bundle-link-url') : '';
    var label = matchedResultEl ? matchedResultEl.getAttribute('data-bundle-link-label') : '';

    if (!url) {
      this.bundleLink.hidden = true;
      return;
    }

    this.bundleLink.href = url;
    if (this.bundleLinkLabel) this.bundleLinkLabel.textContent = label || 'View Full Bundle Details';
    this.bundleLink.hidden = false;
  };

  ProductQuiz.prototype.handleBundleLinkClick = function (event) {
    var url = this.bundleLink.getAttribute('href');
    if (!url || url === '#') return;

    var matched = this.results.filter(function (resultEl) {
      return !resultEl.hidden;
    })[0];

    this.root.dispatchEvent(new CustomEvent('product-quiz:bundle-link-clicked', {
      detail: {
        url: url,
        label: this.bundleLinkLabel ? this.bundleLinkLabel.textContent.trim() : '',
        tag: matched ? matched.getAttribute('data-result-tag') : '',
        email: this.email
      },
      bubbles: true
    }));

    // Give tracking listeners (e.g. the Klaviyo bridge) a brief head start
    // before the browser navigates away — an in-flight request can
    // otherwise get cut off by the page unload before it reaches the
    // network.
    event.preventDefault();
    window.setTimeout(function () {
      window.location.href = url;
    }, 250);
  };

  ProductQuiz.prototype.dispatchComplete = function (matchedResultEl, winningTag) {
    var title = matchedResultEl ? matchedResultEl.querySelector('.product-quiz__result-title') : null;
    var detail = {
      tag: winningTag,
      resultTitle: title ? title.textContent.trim() : '',
      answers: this.answers,
      email: this.email,
      firstName: this.firstName,
      phone: this.phone,
      smsOptIn: this.smsOptIn,
      properties: this.klaviyoProperties()
    };
    this.root.dispatchEvent(new CustomEvent('product-quiz:complete', { detail: detail, bubbles: true }));
  };

  ProductQuiz.prototype.klaviyoProperties = function () {
    var props = {
      quiz_bundle: this.bundleTag || '',
      quiz_first_name: this.firstName || '',
      quiz_phone: this.phone || '',
      quiz_sms_opt_in: this.smsOptIn ? 'true' : 'false'
    };
    this.steps.forEach(function (step, index) {
      if (!this.stepIsVisible(step)) return;
      var answer = this.answers[index];
      if (!answer) return;
      var name = answer.klaviyoProperty;
      if (!name) return;
      var value = (answer.values && answer.values.length)
        ? answer.values.join(', ')
        : (answer.value != null ? String(answer.value) : '');
      if (value) props[name] = value;
    }, this);
    return props;
  };

  ProductQuiz.prototype.answerTextForRole = function (role) {
    var self = this;
    var match = null;
    this.steps.some(function (step, index) {
      if (step.getAttribute('data-quiz-role') !== role) return false;
      if (!self.stepIsVisible(step)) return false;
      var answer = self.answers[index];
      if (!answer) return false;
      match = (answer.values && answer.values.length)
        ? answer.values.join(', ')
        : (answer.value != null ? String(answer.value) : '');
      return true;
    });
    return match || '';
  };

  ProductQuiz.prototype.softenAnswer = function (value) {
    if (!value) return '';
    return value.charAt(0).toLowerCase() + value.slice(1);
  };

  ProductQuiz.prototype.renderPersonalization = function (resultEl) {
    var el = resultEl.querySelector('[data-quiz-personalization]');
    if (!el) return;
    var template = el.getAttribute('data-template') || '';
    if (!template) {
      el.hidden = true;
      return;
    }
    var text = template
      .replace(/\{first_name\}/g, this.firstName || '')
      .replace(/\{q1\}/g, this.softenAnswer(this.answerTextForRole('router')))
      .replace(/\{branch_q1\}/g, this.softenAnswer(this.answerTextForRole('branch')));
    text = text.replace(/\s+/g, ' ').trim();
    el.textContent = text;
    el.hidden = !text;
  };

  ProductQuiz.prototype.applyQuizFlavorsToResult = function (resultEl) {
    var flavors = {};
    Object.keys(this.answers).forEach(function (key) {
      var answer = this.answers[key];
      if (!answer || answer.type !== 'flavor' || !answer.flavors) return;
      Object.keys(answer.flavors).forEach(function (handle) {
        flavors[handle] = answer.flavors[handle];
      });
    }, this);

    Array.prototype.slice.call(resultEl.querySelectorAll('[data-quiz-bundle-flavor]')).forEach(function (select) {
      var handle = select.getAttribute('data-product-handle');
      if (handle && flavors[handle]) select.value = flavors[handle];
    });
  };

  ProductQuiz.prototype.syncCartAttributes = function (matchedResultEl, winningTag) {
    // Quiz answers are NOT written as cart attributes (those stick after the
    // cart is emptied). Persist in localStorage for this browser; profile
    // sync belongs on product-quiz:complete → Klaviyo / CRM, not the cart.
    var payload = {
      answers: {},
      result: '',
      savedAt: new Date().toISOString()
    };
    var titleEl = matchedResultEl ? matchedResultEl.querySelector('.product-quiz__result-title') : null;

    Object.keys(this.answers).forEach(function (key) {
      var answer = this.answers[key];
      var label = answer && answer.question ? String(answer.question) : String(key);
      var value;
      if (answer.type === 'scale' || answer.type === 'number') {
        value = answer.unit ? answer.value + ' ' + answer.unit : String(answer.value);
      } else {
        value = (answer.values || []).join(', ');
      }
      if (value) payload.answers[label] = value;
    }, this);

    payload.result = titleEl ? titleEl.textContent.trim() : winningTag;

    try {
      window.localStorage.setItem('ambrosia_quiz_answers', JSON.stringify(payload));
    } catch (e) {}
  };

  ProductQuiz.prototype.getItemPayload = function (item) {
    var select = item.querySelector('[data-quiz-item-variant]');
    var qtyInput = item.querySelector('.quantity__input');
    var variantId = select
      ? parseInt(select.value, 10)
      : parseInt(item.getAttribute('data-variant-id'), 10);
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    return variantId ? { id: variantId, quantity: quantity } : null;
  };

  ProductQuiz.prototype.getItemMeta = function (item) {
    var titleEl = item.querySelector('.product-quiz__bundle-item-title');
    var priceEl = item.querySelector('[data-quiz-item-price]');
    var select = item.querySelector('[data-quiz-item-variant]');
    var selectedOption = select ? select.options[select.selectedIndex] : null;

    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      variantTitle: selectedOption ? selectedOption.textContent.trim() : '',
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  };

  // One request per line item instead of a single combined /cart/add.js
  // call — Shopify validates a multi-item add as all-or-nothing, so one
  // out-of-stock component would otherwise silently block every item in
  // the bundle from being added.
  ProductQuiz.prototype.addCartItem = function (cartItem, meta) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartItem)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return {
            ok: response.ok,
            item: cartItem,
            meta: meta || {},
            error: response.ok ? null : (data && (data.description || data.message)) || 'Out of stock'
          };
        });
      })
      .catch(function () {
        return { ok: false, item: cartItem, meta: meta || {}, error: 'Something went wrong' };
      });
  };

  ProductQuiz.prototype.refreshAndOpenCartDrawer = function (addedVariantId) {
    if (typeof window.refreshCart === 'function') {
      var rc = window.refreshCart({ openDrawer: true });
      return rc && typeof rc.then === 'function' ? rc : Promise.resolve();
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderOrRefresh === 'function') {
      return cartDrawer.renderOrRefresh(
        { id: addedVariantId || null, sections: {} },
        { openDrawer: true, productId: addedVariantId || null }
      );
    }

    if (cartDrawer && typeof cartDrawer.refreshSections === 'function') {
      return cartDrawer.refreshSections({ openDrawer: true, productId: addedVariantId || null });
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      return fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          return cartDrawer.renderContents({
            id: addedVariantId || null,
            sections: sections || {}
          });
        });
    }

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }

    return Promise.resolve();
  };

  ProductQuiz.prototype.setButtonBusy = function (button, kind) {
    if (!button) return;

    var status = button.querySelector('[data-btn-status]');
    if (!status) {
      status = document.createElement('span');
      status.className = 'product-quiz__order-summary-btn-status';
      status.setAttribute('data-btn-status', '');
      status.setAttribute('aria-live', 'polite');
      button.appendChild(status);
    }

    button.classList.remove('is-busy', 'is-loading', 'is-success', 'is-error');
    status.hidden = true;
    status.innerHTML = '';
    button.removeAttribute('aria-busy');

    if (!kind) return;

    var html = '';
    if (kind === 'loading') {
      html = '<span class="product-quiz__btn-spinner" aria-hidden="true"></span><span>Adding…</span>';
      button.setAttribute('aria-busy', 'true');
    } else if (kind === 'success') {
      html = '<span class="product-quiz__btn-check" aria-hidden="true"><svg viewBox="0 0 16 16" width="14" height="14" fill="none"><path d="M3.2 8.3l3.1 3.2 6.5-6.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>Added</span>';
    } else if (kind === 'error') {
      html = '<span>Couldn’t add</span>';
    }

    button.classList.add('is-busy', 'is-' + kind);
    status.hidden = false;
    status.innerHTML = html;
  };

  ProductQuiz.prototype.postCartAdd = function (items, statusEl, button, metaList) {
    var self = this;
    var setStatus = function (text, isError) {
      if (!statusEl) return;
      statusEl.textContent = text;
      statusEl.hidden = !text;
      statusEl.classList.toggle('product-quiz__bundle-item-status--error', !!isError);
      statusEl.classList.toggle('product-quiz__order-summary-status--error', !!isError);
      statusEl.classList.toggle('product-quiz__bundle-cta-status--error', !!isError);
    };

    if (!items.length) {
      self.setButtonBusy(button, null);
      setStatus('Select at least one product first.', true);
      return;
    }

    if (button) button.disabled = true;
    setStatus('');
    self.setButtonBusy(button, 'loading');

    var outcomes = [];
    var chain = Promise.resolve();
    items.forEach(function (cartItem, i) {
      var meta = (metaList && metaList[i]) || {};
      chain = chain.then(function () {
        return self.addCartItem(cartItem, meta).then(function (outcome) {
          outcomes.push(outcome);
        });
      });
    });

    chain.then(function () {
      var succeeded = outcomes.filter(function (o) { return o.ok; });
      var failed = outcomes.filter(function (o) { return !o.ok; });

      if (!failed.length) {
        self.setButtonBusy(button, 'success');
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      } else if (succeeded.length) {
        self.setButtonBusy(button, null);
        if (button) button.disabled = false;
        var names = failed.map(function (o) { return o.meta.title || 'an item'; }).join(', ');
        setStatus('Added ' + succeeded.length + ' of ' + outcomes.length + ' items — out of stock: ' + names, true);
      } else {
        self.setButtonBusy(button, 'error');
        if (button) button.disabled = false;
        setStatus(failed[0].error || 'Something went wrong — please try again.', true);
      }

      if (succeeded.length) {
        var enrichedItems = succeeded.map(function (o) {
          return {
            id: o.item.id,
            quantity: o.item.quantity,
            title: o.meta.title || '',
            variantTitle: o.meta.variantTitle || '',
            price: o.meta.price || ''
          };
        });

        document.dispatchEvent(new CustomEvent('product-quiz:added-to-cart', {
          detail: { items: enrichedItems, email: self.email },
          bubbles: true
        }));

        self.refreshAndOpenCartDrawer(succeeded[0].item.id).catch(function () {});
      }
    }).catch(function () {
      self.setButtonBusy(button, 'error');
      if (button) button.disabled = false;
      setStatus('Something went wrong — please try again.', true);
    });
  };

  // "variantId::title::price::priceCents;;variantId::title::price::priceCents;;..."
  // — see sections/product-quiz.liquid (bundle_cart_items_for_js) for the
  // source. priceCents (added alongside the pre-formatted price string)
  // feeds recomputeOrderSummary's client-side total, avoiding re-parsing
  // formatted currency text.
  // Parses one "variantId::title::price::priceCents" list (";;"-joined) into
  // cart-add item/meta entries, tagging each with the given line properties.
  function parseCartItemsList(raw, quantity, properties) {
    var items = [];
    var metaList = [];
    (raw || '').split(';;').forEach(function (entry) {
      if (!entry) return;
      var parts = entry.split('::');
      var variantId = parseInt(parts[0], 10);
      if (!variantId) return;
      items.push({ id: variantId, quantity: quantity, properties: Object.assign({}, properties || {}) });
      metaList.push({
        title: parts[1] || '',
        variantTitle: '',
        price: parts[2] || '',
        priceCents: parseInt(parts[3], 10) || 0,
        handle: (parts[4] || '').trim(),
        sellingPlanId: (parts[5] || '').trim()
      });
    });
    return { items: items, metaList: metaList };
  }

  ProductQuiz.prototype.getCartSourceEl = function (resultEl) {
    if (!resultEl) return null;
    var summary = resultEl.querySelector('[data-quiz-order-summary]');
    if (summary && summary.getAttribute('data-bundle-cart-items')) return summary;
    if (resultEl.getAttribute('data-bundle-cart-items')) return resultEl;
    return resultEl.querySelector('[data-quiz-item][data-bundle-cart-items]');
  };

  ProductQuiz.prototype.applyFlavorSelections = function (item, parsed) {
    var scope = item.closest('[data-quiz-result]') || item;
    var flavorByHandle = {};
    Array.prototype.slice.call(scope.querySelectorAll('[data-quiz-bundle-flavor]')).forEach(function (select) {
      var handle = select.getAttribute('data-product-handle');
      var option = select.options[select.selectedIndex];
      if (!handle || !option) return;
      flavorByHandle[handle] = {
        id: parseInt(option.value, 10),
        sellingPlanId: (option.getAttribute('data-selling-plan-id') || '').trim()
      };
    });

    parsed.items.forEach(function (cartItem, i) {
      var meta = parsed.metaList[i] || {};
      var flavor = meta.handle && flavorByHandle[meta.handle];
      if (!flavor || !flavor.id) return;
      cartItem.id = flavor.id;
      if (flavor.sellingPlanId) meta.sellingPlanId = flavor.sellingPlanId;
    });
  };

  ProductQuiz.prototype.applyPurchaseType = function (item, parsed, purchaseType) {
    var subscribe = purchaseType !== 'onetime';
    parsed.items.forEach(function (cartItem, i) {
      var sellingPlanId = parsed.metaList[i] && parsed.metaList[i].sellingPlanId;
      if (sellingPlanId) {
        cartItem.properties = cartItem.properties || {};
        cartItem.properties._selling_plan_id = String(sellingPlanId);
      }
      if (subscribe && sellingPlanId) {
        cartItem.selling_plan = sellingPlanId;
      } else if (cartItem.selling_plan) {
        delete cartItem.selling_plan;
      }
    });
  };

  ProductQuiz.prototype.getBundleCartItems = function (item, purchaseType) {
    var raw = item.getAttribute('data-bundle-cart-items');
    if (!raw) return null;

    var qtyInput = item.querySelector('.quantity__input');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 1;
    if (quantity <= 0) return null;

    // Paid lines use the same _bundle_item / _bundle_id properties as the
    // Bundle Builder so Shopify's discount function applies the matching
    // quantity tier. Free gifts stay on quiz-only properties so they are
    // not counted toward that tier.
    var bundleId = 'bb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
    var quizBundleId = 'pq-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var targetCents = item.getAttribute('data-target-cents') || '';
    var expectedPaidCount = raw.split(';;').filter(function (entry) { return entry; }).length;

    var paid = parseCartItemsList(raw, quantity, {
      _bundle_item: 'true',
      _bundle_id: bundleId
    });
    this.applyFlavorSelections(item, paid);
    this.applyPurchaseType(item, paid, purchaseType || 'subscribe');

    var items = paid.items;
    var metaList = paid.metaList;

    var freebieRaw = item.getAttribute('data-freebie-cart-items');
    if (freebieRaw) {
      var gifts = parseCartItemsList(freebieRaw, quantity, {
        _quiz_bundle_id: quizBundleId,
        _quiz_target_cents: targetCents,
        _quiz_expected_paid_count: String(expectedPaidCount),
        _quiz_free_gift: 'true'
      });
      items = items.concat(gifts.items);
      metaList = metaList.concat(gifts.metaList);
    }

    return items.length ? { items: items, metaList: metaList } : null;
  };

  ProductQuiz.prototype.addItemToCart = function (item, button, statusElOverride, purchaseType) {
    var statusEl = statusElOverride || item.querySelector('[data-order-summary-status]') || item.querySelector('[data-quiz-item-status]');

    try {
      var bundleCart = this.getBundleCartItems(item, purchaseType);
      if (bundleCart) {
        this.postCartAdd(bundleCart.items, statusEl, button, bundleCart.metaList);
        return;
      }

      var payload = this.getItemPayload(item);
      if (!payload) {
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent = 'Unable to add this bundle — please refresh and try again.';
          statusEl.classList.add('product-quiz__order-summary-status--error');
        }
        return;
      }
      this.postCartAdd([payload], statusEl, button, [this.getItemMeta(item)]);
    } catch (err) {
      if (button) button.disabled = false;
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = 'Something went wrong — please try again.';
        statusEl.classList.add('product-quiz__order-summary-status--error');
      }
    }
  };

  ProductQuiz.prototype.retake = function () {
    var self = this;
    this.answers = {};
    this.index = 0;
    this.bundleTag = '';
    this.smsOptIn = false;
    this.emailCaptured = false;
    this.clearStorage();
    this.loadLeadFromStorage();

    this.steps.forEach(function (step) {
      step.hidden = true;
      step.querySelectorAll('[data-quiz-option]').forEach(function (option) {
        option.setAttribute('aria-checked', 'false');
      });
      var scale = step.querySelector('[data-quiz-scale], [data-quiz-number]');
      var output = step.querySelector('[data-quiz-scale-value]');
      if (scale) {
        scale.value = scale.min;
        if (output) output.textContent = self.formatScaleValue(scale);
      }
      var sms = step.querySelector('[data-quiz-lead-sms]');
      if (sms) sms.checked = false;
      self.updateNextButtonState(step);
    });

    this.applyLeadFields(true);

    this.results.forEach(function (resultEl) {
      resultEl.hidden = true;

      // Reset any prior "removed" (qty 0) state so a retaken quiz doesn't
      // land back on this result already deselected.
      var selectRow = resultEl.querySelector('[data-quiz-select-row]');
      if (selectRow) {
        var featuredItem = selectRow.closest('[data-quiz-item]');
        var qtyInput = featuredItem ? featuredItem.querySelector('.quantity__input') : null;
        if (qtyInput && (parseInt(qtyInput.value, 10) || 0) <= 0) {
          qtyInput.value = 1;
        }
        if (featuredItem) self.syncFeaturedSelection(featuredItem, resultEl);
      }
    });
    if (this.resultsPanel) this.resultsPanel.hidden = true;
    if (this.stepsContainer) this.stepsContainer.hidden = false;

    if (this.intro) {
      this.intro.hidden = false;
      if (this.progress) this.progress.hidden = true;
    } else if (this.steps.length) {
      if (this.progress) this.progress.hidden = !this.progressEnabled;
      this.showStep(0);
    }
  };

  ProductQuiz.prototype.readStorage = function () {
    try {
      var raw = window.localStorage.getItem(this.storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  ProductQuiz.prototype.readLeadStorage = function () {
    try {
      var raw = window.localStorage.getItem(LEAD_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  ProductQuiz.prototype.persistLeadStorage = function () {
    if (!this.firstName && !this.email && !this.phone) return;
    try {
      window.localStorage.setItem(
        LEAD_STORAGE_KEY,
        JSON.stringify({
          firstName: this.firstName || '',
          email: this.email || '',
          phone: this.phone || ''
        })
      );
    } catch (e) {}
  };

  ProductQuiz.prototype.loadLeadFromStorage = function () {
    var stored = this.readLeadStorage();
    if (!stored) return;
    if (stored.firstName) this.firstName = stored.firstName;
    if (stored.email) this.email = stored.email;
    if (stored.phone) this.phone = stored.phone;
  };

  ProductQuiz.prototype.applyLeadFields = function (overwrite) {
    var self = this;
    this.steps.forEach(function (step) {
      var first = step.querySelector('[data-quiz-lead-first-name]');
      var email = step.querySelector('[data-quiz-lead-email]');
      var phone = step.querySelector('[data-quiz-lead-phone]');
      if (!first && !email && !phone) return;
      if (first && self.firstName && (overwrite || !first.value)) first.value = self.firstName;
      if (email && self.email && (overwrite || !email.value)) email.value = self.email;
      if (phone && self.phone && (overwrite || !phone.value)) phone.value = self.phone;
      self.updateNextButtonState(step);
    });
    if (this.emailInput && this.email && (overwrite || !this.emailInput.value)) {
      this.emailInput.value = this.email;
    }
  };

  ProductQuiz.prototype.persistState = function (resultTag, completed) {
    if (!this.persist) return;
    try {
      window.localStorage.setItem(
        this.storageKey,
        JSON.stringify({
          version: STATE_VERSION,
          index: this.index,
          answers: this.answers,
          completed: !!completed,
          resultTag: resultTag || null,
          email: this.email || '',
          bundleTag: this.bundleTag || '',
          firstName: this.firstName || '',
          phone: this.phone || '',
          smsOptIn: !!this.smsOptIn
        })
      );
    } catch (e) {}
  };

  ProductQuiz.prototype.clearStorage = function () {
    try {
      window.localStorage.removeItem(this.storageKey);
    } catch (e) {}
  };

  function init() {
    var roots = document.querySelectorAll('[data-product-quiz]');
    roots.forEach(function (root) {
      if (root.__productQuizInitialized) return;
      root.__productQuizInitialized = true;
      new ProductQuiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-product-quiz]');
    if (root && !root.__productQuizInitialized) {
      root.__productQuizInitialized = true;
      new ProductQuiz(root);
    }
  });
})();
